var map = {
	"./1/room-3.jpg": "e23c",
	"./2/room-3.jpg": "e8a3",
	"./3/room-3.jpg": "2286",
	"./4/room-3.jpg": "08bb",
	"./5/room-3.jpg": "f0af"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9b9b";